module.exports = __webpack_public_path__ + "static/media/WIN1.2a38db20.apng";